import MixinScroll from '../mixin-scroll'


export default
{
    mixins: [
        MixinScroll
    ],

    props: {
        min: { type: Array, default: () => [0] },  
        max: { type: Array, default: () => [500] },
        colors: { type: Array, default: () => ['#000'] },
        bgColor: { type: String, default: '#FFF' }
    },

    data()
    {
        return {
            isIn: true
        }
    },

    mounted()
    {
        this.onTick()
        this.onScroll(this.scroll.realY)
    },

    destroyed()
    {
        cancelAnimationFrame(this._tickRaf)
    },
  
    methods:
    {
        onTick()
        {
            if (!this.list)
            {
                this.list = this.$refs.bars.map(el => ({
                    el,
                    current: -100,
                    next: -100
                }))
            }

            this.list.forEach(data => 
            {
                data.current += (data.next - data.current) / 20
                data.el.style.transform = 'translateY(' + data.current.toFixed(2) + '%) translateZ(0)'
            })

            this._tickRaf = requestAnimationFrame(this.onTick)
        },

        onScroll(y)
        {
            const totalScale = Math.min(0, 100 * (y - this.min[0]) / (this.max[this.max.length - 1] - this.min[0]) - 100)
            this.isIn = totalScale > -100 && totalScale < 0
            for (let i = 0; !!this.list && i < this.list.length; i++)
            {
                const scale = (y - this.min[i]) / (this.max[i] - this.min[i])
                this.list[i].next = scale >= 0 ? totalScale : -100
            }
        }
    }
}